const { Http } = require('./httpService')

class BillingSDK {
    constructor({
                    authInstance,
                    apiTMKey,
                    isDebugMode = false
                }) {
        this.baseTMURL = 'https://subs.platforms.team';
        this.apiTMKey = apiTMKey;
        this.subscriptions = null;
        this.authInstance = authInstance;
        this.isDebugMode = isDebugMode;
        this.http = new Http();
    }

    overrideBaseTMURL(url) {
        this.baseTMURL = url;
    }

    debugChecker() {
        if(this.isDebugMode) {
            if(!this.authInstance.authToken) {
                console.debug('no token');
                return false;
            }
        }

        return true;
    }

    makeHash(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random()
                * charactersLength));
        }

        return result;
    }

    getPaymentPlans() {
        this.debugChecker();
        return this.http.get(`${this.authInstance.baseURL}/api/payment/plans`, {
                Authorization: `Bearer ${this.authInstance.authToken}`,
                'X-API-KEY': this.authInstance.apiKey
            }
        );
    }

    paymentCheckout({
                        nonce,
                        planId
                    }) {
        this.debugChecker();
        return this.http.post(`${this.authInstance.baseURL}/api/payment/checkout`, {
                nonce,
                plan_id: planId
            }, {
                Authorization: `Bearer ${this.authInstance.authToken}`,
                'X-API-KEY': this.authInstance.apiKey
            }
        );
    }

    getPaymentProfile() {
        return this.http.get(`${this.authInstance.baseURL}/api/payment/profile`, {
            Authorization: `Bearer ${this.authInstance.authToken}`,
            'X-API-KEY': this.authInstance.apiKey
        });
    }

    getSubscriptions() {
        this.debugChecker();
        return this.http.get(`${this.authInstance.baseURL}/api/payment/subscription`, {
                Authorization: `Bearer ${this.authInstance.authToken}`,
                'X-API-KEY': this.authInstance.apiKey
            }
        )
            .then(response => {
                this.subscriptions = response.data;
                return response;
            });
    }

    deleteSubscription(id) {
        this.debugChecker();
        return this.http.delete(`${this.authInstance.baseURL}/api/payment/subscription/${id}`, {
            Authorization: `Bearer ${this.authInstance.authToken}`,
            'X-API-KEY': this.authInstance.apiKey
        })
            .then(response => {
                if (this.subscriptions && this.subscriptions.length) {
                    this.subscriptions = this.subscriptions.filter(({ id }) => !!id);
                }
                return response;
            });
    }

    verify(encryptData, decrypt) {
        const bodyFormData = new FormData();
        const hash = this.makeHash(10);
        let data = JSON.stringify({
            token: this.authInstance.authToken,
            hash: hash,
            deviceData: {
                domain: window.location.hostname,
                api_key: this.authInstance.apiKey,
                user_agent: navigator.userAgent,
            },
        });

        if(encryptData) {
            data = encryptData(data);
        } else {
            data = btoa(data);
        }
        bodyFormData.append('api_key', this.apiTMKey);
        bodyFormData.append('data', data);
        const parseDate = encryptData ? (response) => response.text() :
            (response) => response.json();
        return fetch(`${this.baseTMURL}/v1/web/verify`, {
            method: 'POST',
            body: bodyFormData,
        })
            .then(parseDate)
            .then((response) => {
                if(decrypt) {
                    response = decrypt(response);
                }

                if (response.hash === hash) {
                    this.subscriptions = response.data.subscriptions;
                    return response.data.subscriptions;
                } else {
                    return Promise.reject(new Error('Wrong hash'));
                }
            });
    }
}

module.exports = BillingSDK;
